// Two-cartridge icon for Ammo. Stroke follows the text colour (tab normal / active colours).
const AmmoIconSvg = ({
  height = 24,
  width = 24,
  viewBox = '0 0 24 24',
  stroke = 'currentColor',
  strokeWidth = 1.5,
  className = '',
}: {
  height?: number | string;
  width?: number | string;
  viewBox?: string;
  stroke?: string;
  strokeWidth?: number | string;
  className?: string;
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox={viewBox}
      fill="none"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.5 8C9.5 5 8 2 8 2C8 2 6.5 5 6.5 8M9.5 8H6.5M9 19C9.26522 19 9.51957 18.8946 9.70711 18.7071C9.89464 18.5196 10 18.2652 10 18V10.5L9.5 8M7 19C6.73478 19 6.48043 18.8946 6.29289 18.7071C6.10536 18.5196 6 18.2652 6 18V10.5L6.5 8M10 10.5H6M7 19H9M7 19C6.73478 19 6.48043 19.1054 6.29289 19.2929C6.10536 19.4804 6 19.7348 6 20V22H10V20C10 19.7348 9.89464 19.4804 9.70711 19.2929C9.51957 19.1054 9.26522 19 9 19M17.5 8C17.5 5 16 2 16 2C16 2 14.5 5 14.5 8M17.5 8H14.5M17 19C17.2652 19 17.5196 18.8946 17.7071 18.7071C17.8946 18.5196 18 18.2652 18 18V10.5L17.5 8M15 19C14.7348 19 14.4804 18.8946 14.2929 18.7071C14.1054 18.5196 14 18.2652 14 18V10.5L14.5 8M18 10.5H14M15 19H17M15 19C14.7348 19 14.4804 19.1054 14.2929 19.2929C14.1054 19.4804 14 19.7348 14 20V22H18V20C18 19.7348 17.8946 19.4804 17.7071 19.2929C17.5196 19.1054 17.2652 19 17 19"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default AmmoIconSvg;
